export const socialFormActionsStyle = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		rowGap: '8px',
		width: '100%',
		fontSize: '16px',
		lineHeight: '20px',
	},

	divider: {
		marginBottom: '16px',

		'&::before': {
			borderTop: ' 1px solid var(--neutral-100)',
		},

		'&::after': {
			borderTop: ' 1px solid var(--neutral-100)',
		},
	},
};
